//
//
//
//
//
//
//
//
//
//

import Vue from 'vue'
import { Menu, MenuItem } from 'element-ui'

Vue.use(Menu).use(MenuItem)
export default {
    props: {
        leftMenus: Array
    },
    data() {
        return {
            curIndex: 0
        }
    },
    watch: {
        leftMenus: {
            handler(menus) {
                this.curIndex = 0
                var curIndex = menus.findIndex(menu => menu.url === this.$route.path)
                if (curIndex > -1) {
                    this.curIndex = curIndex
                }
                var curMenu = menus[curIndex] || menus[0]
                if (curMenu) {
                    this.goMenu(curMenu)
                }
            },
            immediate: true
        }
    },
    methods: {
        clickMenu(menu, index) {
            this.curIndex = index
            this.goMenu(menu)
        },
        goMenu(menu) {
            if (this.$route.path !== menu.url)
                this.$router.push(menu.url)
        }
    }
}
